export class TagId {
  static readonly irregular = '00000000'

  constructor(readonly id: string) {}

  get isTimeouted(): boolean {
    return (
      this.id === '7d080020' ||
      this.id === '81080020' ||
      this.id === TagId.irregular
    )
  }

  equals(other: TagId): boolean {
    return other instanceof TagId && other.id === this.id
  }
}
